const RouteSkeleton = () => (
  <div className="min-h-screen bg-background" aria-busy="true" aria-label="Loading">
    {/* Header silhouette */}
    <div className="h-14 border-b border-border/30 bg-white/80 backdrop-blur-md px-4 flex items-center justify-between">
      <div className="flex items-center gap-3">
        <div className="h-5 w-5 rounded-md bg-muted/70 animate-pulse" />
        <div className="h-6 w-24 rounded-md bg-muted/70 animate-pulse" />
      </div>
      <div className="flex items-center gap-3">
        <div className="h-5 w-5 rounded-full bg-muted/70 animate-pulse" />
        <div className="h-5 w-5 rounded-full bg-muted/70 animate-pulse" />
        <div className="h-5 w-5 rounded-full bg-muted/70 animate-pulse" />
      </div>
    </div>
    {/* Content silhouette */}
    <div className="max-w-5xl mx-auto px-4 py-8 space-y-4">
      <div className="h-8 w-2/3 rounded-md bg-muted/60 animate-pulse" />
      <div className="h-4 w-1/2 rounded-md bg-muted/50 animate-pulse" />
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 pt-4">
        {Array.from({ length: 6 }).map((_, i) => (
          <div
            key={i}
            className="aspect-[4/3] rounded-2xl bg-muted/50 animate-pulse"
            style={{ animationDelay: `${i * 80}ms` }}
          />
        ))}
      </div>
    </div>
  </div>
);

export default RouteSkeleton;
